import { Button } from "@chakra-ui/button";
import { useDisclosure } from "@chakra-ui/hooks";
import { ChevronDownIcon, ChevronUpIcon } from "@chakra-ui/icons";
import { Collapse } from "@chakra-ui/transition";
import styled from "@emotion/styled";
import React from "react";
import useFormCalculationWarnings from "../../hooks/useFormCalculationWarnings";
import {
  FormStatusColorMap,
  StatusColors,
} from "../../lib/models/form-status-colors";

export interface FormCalcStatusListProps {
  label: string;
  icon?: JSX.Element;
  items: string | Array<string> | undefined;
  colorScheme: StatusColors;
}

function FormCalcStatusList(props: FormCalcStatusListProps) {
  const { label, icon, items, colorScheme } = props;
  const infoList = useFormCalculationWarnings(items ?? "");
  const { isOpen, onToggle } = useDisclosure();

  const colors = React.useMemo(() => {
    return FormStatusColorMap[colorScheme];
  }, [colorScheme]);

  if (!items || items.length < 1) return null;

  return (
    <WarningContent
      textColor={colors.textColor}
      backgroundColor={colors.backgroundColor}
    >
      <Button
        variant="unstyled"
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        leftIcon={icon}
        rightIcon={
          isOpen ? (
            <ChevronUpIcon h={5} w={5} />
          ) : (
            <ChevronDownIcon h={5} w={5} />
          )
        }
        onClick={onToggle}
        fontSize="sm"
        width="full"
      >
        {infoList.length} {label}
      </Button>

      <Collapse in={isOpen} animateOpacity>
        <ul>
          {infoList.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
      </Collapse>
    </WarningContent>
  );
}

export default FormCalcStatusList;

const WarningContent = styled.div(
  (props: { textColor: string; backgroundColor: string }) => ({
    padding: "var(--chakra-space-1) var(--chakra-space-4)",
    backgroundColor: props.backgroundColor,
    color: props.textColor,
    width: "100%",
    borderRadius: "var(--chakra-radii-md)",

    ul: {
      marginTop: "var(--chakra-space-2)",
      marginLeft: "var(--chakra-space-6)",
    },

    li: {
      fontSize: "var(--chakra-fontSizes-sm)",
      padding: "var(--chakra-space-1) 0",
    },
  })
);
